export interface PaintCorrectionFocus {
  id: string
  name: string
  summary: string
}

export const paintCorrectionFocus: PaintCorrectionFocus[] = [
  {
    id: 'swirl-removal',
    name: 'Swirl reduction',
    summary: 'Machine polishing to reduce wash marks, holograms and light marring in the clear coat.',
  },
  {
    id: 'clarity',
    name: 'Paint clarity',
    summary: 'Restore optical clarity so colour and metallic flake read more cleanly in daylight.',
  },
  {
    id: 'gloss',
    name: 'Gloss restoration',
    summary: 'Refine the surface so the finish looks deeper, wetter and more uniform.',
  },
  {
    id: 'ceramic-prep',
    name: 'Ceramic preparation',
    summary: 'Correct and refine paint before GYEON ceramic coating, so protection sits on a cleaner, more even surface.',
  },
]

export const paintCorrectionPage = {
  eyebrow: 'Paint Correction',
  title: 'Paint Correction',
  titleHighlight: 'Bellarine & Geelong',
  intro:
    'Professional machine polishing from the Drysdale studio. Correction is matched to the paint in front of Lyle — it reduces visible defects; it does not promise a perfect, defect-free finish.',
  whatItIs:
    'Paint correction is controlled machine polishing of the clear coat. The aim is to reduce swirls, light scratches and oxidation so the paint looks clearer and glossier, then to leave the surface ready for ceramic protection where that is the next step.',
  whoItSuits:
    'Daily drivers with wash marring, vehicles being prepared for ceramic coating, and cars where the finish looks dull or hazy rather than sharp. Heavily neglected or previously poorly polished paint is assessed in the studio before any work is recommended.',
  issuesHeading: 'Common issues it improves',
  issues: [
    'Swirl marks and holograms from washing',
    'Light surface scratches in the clear coat',
    'Haze, dullness and reduced gloss',
    'Light oxidation and water-spot etching where the clear coat allows',
  ],
  caveat:
    'Every panel is different. Some defects sit too deep to remove safely. Autoglow will not chase 100% defect removal at the expense of remaining clear coat.',
  priceNote:
    'Paint correction is quoted after inspection. Depth of correction, vehicle size and paint condition all change the work required — there is no public fixed menu price.',
  protectionHeading: 'Protect the corrected finish',
  protectionCopy:
    'Once the paint is corrected, a GYEON ceramic coating helps lock in the gloss and makes ongoing maintenance easier. Pair correction with 1, 3 or 5 year ceramic protection when the vehicle is a good candidate.',
  quoteHref: '/detailing/quote?interests=paint-correction',
}
